module.exports = __webpack_public_path__ + "static/img/it.6368eb5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/it.svg
// module id = OMyd
// module chunks = 4